import { DuckSelector } from '@atc/modular-redux';

import { resultsDuckCreator } from 'axl-ducks';

import { vdpDuckPreset } from '@/ducks/presets/index.js';

export default resultsDuckCreator({
    ...vdpDuckPreset,
    store: 'similarlistings',
}).extend({
    selectors: () => ({
        getInitialLoad: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).initialLoad),
    }),
});
